import { v1 as uuidv1 } from "uuid";

export default {
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: null
    },
    preValues: {
      type: Array,
      default: () => ( [] )
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: () => ( {
    instanceId: uuidv1()
  } )
};
